export class CatGoalRegionModel {
    public goalRegionId?:number;
    public regionDescription?:string;

    public commission?:number;
    public commissionFisofo?:number;

    public activeId?:boolean;
    public activeIdFisofo?:boolean;

    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}
